.wrapper {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.content {
	display: flex;
	flex-direction: column;
	gap: 12px;
	text-align: center;
	align-items: center;
}

.content p {
	max-width: 440px;
}

.button {
	margin-top: 16px;
}
